export default __webpack_public_path__ + "static/media/macbook_2.dbe746f1.jpg";